import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { sprintf } from 'sprintf-js';

import { environment } from '../../environments/environment';
import { BaseService } from './base.service';

@Injectable()

export class GlobalTriggerService extends BaseService {
  constructor (
    protected http: HttpClient
  ) {
    super(http, `${environment.apiBaseUrl}/triggers`);
  }
  restoreDefault(id: string, urlParams?: any, params?: any): Observable<any> {
    const url = sprintf(this.baseUrl, urlParams) + `/${id}/default`;
    return this.http.put<any>(url, {}, {
      params: this.toHttpParams({
        ...params,
      })
    });
  }
}